<template>
  <div>
    <router-view v-if="this.$route.path !== '/accountManage/projectManage' && this.$route.path !== '/qianchuan/account/project'" :productList.sync="productList" :activeProductId.sync="activeProductId"></router-view>
    <div v-else class="projectManage">
      <!-- 项目空状态 -->
      <div class="project_null" v-if="nullShow">
        <img class="" src="@/assets/img/project_manage_null.png" alt="" />
        <div class="project_title">欢迎使用道有道智投RPA</div>
        <div class="project_sub">通过项目管理你可以分类管理广告投放账号，在列表与报表中查看项目数据</div>
        <el-button type="primary" round icon="el-icon-plus">创建项目</el-button>
      </div>
      <div v-else>
        <!-- 新增/编辑产品 -->
        <div class="operateProduct">
          <el-dialog :title="productPopupTitle" :visible.sync="operateProductVisible" :close-on-click-modal="false">
            <el-form ref="operateProductForm" :model="operateProductForm" :rules="operateProductRules">
              <el-form-item label="" prop="name">
                <el-input v-model="operateProductForm.name" placeholder="请输入产品名称" maxlength="40"></el-input>
              </el-form-item>
              <el-form-item class="btn">
                <el-button size="small" @click="operateProductVisible = false">取 消</el-button>
                <el-button size="small" type="primary" :loading="postLoading" @click="operateProductSubmit('operateProductForm')">确 定</el-button>
              </el-form-item>
            </el-form>
          </el-dialog>
        </div>
        <!-- 修改所属产品 -->
        <div class="changeProject">
          <el-dialog :title="changeProductTitle" :visible.sync="changeProductVisible" :close-on-click-modal="false">
            <el-form ref="changeProjectForm" :model="changeProjectForm" :rules="changeProjectRules">
              <el-form-item label="" prop="name" v-if="changeProductType === 'editName'">
                <el-input v-model="changeProjectForm.name" placeholder="请输入项目名称"></el-input>
              </el-form-item>
              <el-form-item label="" prop="product" v-else>
                <el-select v-model="changeProjectForm.product" placeholder="请选择所属产品">
                  <el-option v-for="item in changeProductList" :key="item.id" :label="item.productName" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="btn">
                <el-button size="small" @click="changeProductVisible = false">取 消</el-button>
                <el-button size="small" type="primary" :loading="postLoading" @click="changeProjectSubmit('changeProjectForm', changeProductType)">确 定</el-button>
              </el-form-item>
            </el-form>
          </el-dialog>
        </div>
        <!-- 修改所属项目团队成员 -->
        <div class="chargeMan">
          <el-dialog v-if="chargeManVisible" title="所属项目团队成员" :visible.sync="chargeManVisible" :close-on-click-modal="false">
            <el-form ref="chargeManFormRef" :model="chargeManForm" :rules="chargeManFormRules">
              <el-form-item label="" prop="employeeIdList">
                <el-select v-model="chargeManForm.employeeIdList" multiple placeholder="请选择所属项目团队成员">
                  <el-option v-for="item in employeeList" :key="item.id" :label="item.employeeName" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="btn">
                <el-button size="small" @click="chargeManVisible = false">取 消</el-button>
                <el-button size="small" type="primary" @click="chargeManSubmit">确 定</el-button>
              </el-form-item>
            </el-form>
          </el-dialog>
        </div>
        <!-- 分配投放账户 -->
        <div class="assignAccount">
          <el-dialog title="" :visible.sync="assignAccountVisible" :close-on-click-modal="false">
            <el-form ref="assignAccountForm" :model="assignAccountForm" :rules="assignAccountRules">
              <el-form-item label="分配投放账户" prop="list">
                <div class="category">
                  <div class="icon tt active"></div>
                </div>
                <el-transfer
                  v-loading="assignAccountLoading"
                  v-model="assignAccountForm.list"
                  filterable
                  :titles="['未选择', '已选择']"
                  :format="{
                    noChecked: '0/${total}',
                    hasChecked: '${checked}/${total}'
                  }"
                  @change="handleChange"
                  :data="assignAccountData"
                ></el-transfer>
              </el-form-item>
              <el-form-item class="btn">
                <el-button size="small" @click="assignAccountVisible = false">取 消</el-button>
                <el-button size="small" type="primary" @click="assignAccountSubmit('assignAccountForm', assignAccountProjectId)">保 存</el-button>
              </el-form-item>
            </el-form>
          </el-dialog>
        </div>
        <!-- 查看已分配投放账户 -->
        <div class="viewAccountList">
          <el-dialog title="" :visible.sync="viewAccountVisible" :close-on-click-modal="false">
            <el-form ref="viewAccountForm" :model="viewAccountForm">
              <el-form-item label="已分配投放账户">
                <div class="category">
                  <div class="icon tt active"></div>
                </div>
                <el-table :data="viewAccountForm.list" border stripe height="358">
                  <el-table-column prop="agentAccountName" label="广告投放账户"></el-table-column>
                  <el-table-column prop="agentAccountId" label="账户ID"></el-table-column>
                </el-table>
              </el-form-item>
              <el-form-item class="btn">
                <!-- <el-button size="small" @click="viewAccountVisible=false">取 消</el-button> -->
                <el-button size="small" type="primary" @click="viewAccountVisible = false">取 消</el-button>
              </el-form-item>
            </el-form>
          </el-dialog>
        </div>
        <!-- 项目列表 -->
        <div class="projectCon">
          <div class="productList" v-permission="'project:getProductList'">
            <div class="title clearfix">
              <p>产品</p>
              <!-- <transition>
                <i v-if="show" class="iconfont icon-tianjia-copy" @click="operateProduct('add')" v-permission="'project:addProduct'"></i>
              </transition> -->
              <!--@click="parseInt(sessionStorage.getItem('isIntro'))?'':operateProduct('add')" id="guide-step1"-->
              <el-button type="primary" size="small" icon="" v-permission="'project:addProduct'" @click="operateProduct('add')">
                <i class="iconfont icon-tianjia-copy"></i>
                创建产品
              </el-button>
            </div>
            <!-- <div class="total">全部项目（{{productListTotal}}）</div> -->
            <div class="list">
              <div class="item" v-for="item in productList" :key="item.id" :class="{ active: activeProductId == item.id }" @click="changeProductActive(item.id)">
                <p class="clearfix">
                  <span>{{ item.productName }}</span>
                  <!-- <i v-if="item.productName !== '全部'" class="iconfont icon-edit" @click="operateProduct('edit', item.productName, item.id)" v-permission="'project:addProduct'"></i> -->
                <el-dropdown class="fr" v-if="item.productName !== '全部'">
                  <span class="el-dropdown-link">
                    <i class="iconfont icon-diandiandianshu"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="operateProduct('edit', item.productName, item.id)">编辑</el-dropdown-item>
                    <el-dropdown-item @click.native="operateProduct('delete', item.projectAmount, item.id)">删除</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                </p>
                <div class="num" v-if="item.projectAmount > 0">{{ item.projectAmount }}</div>
              </div>
            </div>
          </div>
          <div class="projectList" v-permission="'project:getProjectList'">
            <div class="top">
              <div class="page-title">投放项目</div>
              <div>
                <!-- <el-button type="primary" @click="startIntroJs()">开启引导</el-button> -->
                <!-- <el-input v-model="searchValue" placeholder="请输入项目名称"></el-input>
                <el-button @click="searchList(searchValue)"><i class="iconfont icon-sousuo"></i></el-button> -->
                <el-input placeholder="请输入项目名称" v-model="searchValue" class="input-with-search">
                  <el-button @click="searchList(searchValue)" slot="append" icon="iconfont icon-sousuo"></el-button>
                </el-input>
              </div>
              <div class="right">
                <!-- <router-link :to="{ name: createProjectName }" tag="div" class="fl"> -->
                  <!--  @click="parseInt(sessionStorage.getItem('isIntro'))?'':createProject" id="guide-step2" -->
                  <el-button type="primary" round icon="" v-permission="'project:saveProject'" @click="createProject">
                    <i class="iconfont icon-tianjia-copy"></i>
                    创建项目
                  </el-button>
                <!-- </router-link> -->
                <el-button v-if="pageTotal > 0" class="fl" type="primary" round icon="iconfont icon-batch" @click="changeProject('batch')" :disabled="projectSelection.length === 0" v-permission="'project:assignProduct'">
                  批量分配产品
                </el-button>
              </div>
            </div>
            <div class="tableBox">
              <el-table class="roleTable" :data="projectList" border @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="80" v-if="pageTotal > 0"></el-table-column>
                <el-table-column label="项目名称">
                  <template slot-scope="scope">
                    <div class="changeProject">
                      {{ scope.row.projectName }}
                      <el-tooltip content="编辑" placement="top" v-if="projectEditProjectName">
                        <i @click="changeProject('editName', scope.row.id, scope.row.projectId, scope.row.projectName)" class="iconfont icon-edit"></i>
                      </el-tooltip>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="所属产品">
                  <template slot-scope="scope">
                    <div v-if="scope.row.productId == 0">
                      <el-tooltip content="分配" placement="top" v-if="assignProductPermission">
                        <p class="red" @click="changeProject('null', scope.row.id, scope.row.productId)">未分配</p>
                      </el-tooltip>
                    </div>
                    <div class="changeProject" v-else>
                      {{ scope.row.productName }}
                      <el-tooltip content="编辑" placement="top" v-if="assignProductPermission">
                        <i @click="changeProject('edit', scope.row.id, scope.row.productId)" class="iconfont icon-edit"></i>
                      </el-tooltip>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="项目团队成员" min-width="120px">
                  <template slot="header" class="tool">
                    <span>项目团队成员</span>
                    <el-tooltip effect="light" placement="right" popper-class="atooltip">
                      <div slot="content">超级管理员可查看所有项目</div>
                      <i class="el-icon-question"></i>
                    </el-tooltip>
                  </template>
                  <template slot-scope="scope">
                    <div v-if="userInfo.userRole==='admin'">
                      <div v-if="scope.row.chargeManList == ''">
                        <el-tooltip content="分配" placement="top" v-if="assignProductPermission">
                          <p class="red" @click="chargeMan(scope.row)">未分配</p>
                        </el-tooltip>
                      </div>
                      <div class="changeProject" v-else>
                        <span style="display: inline-block;" v-html="scope.row.chargeManList"></span>
                        <el-tooltip content="编辑" placement="top">
                          <i class="iconfont icon-edit" style="display: inline-block;" @click="chargeMan(scope.row)"></i>
                        </el-tooltip>
                      </div>
                    </div>
                    <div v-else>
                      <div v-if="scope.row.chargeManList == ''">
                        <p class="red">未分配</p>
                      </div>
                      <div class="changeProject" v-else>
                        <span style="display: inline-block;" v-html="scope.row.chargeManList"></span>
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="关联的广告账户" width="150">
                  <template slot-scope="scope">
                    <div class="linked">
                      <el-tooltip content="分配" placement="top" v-if="assignAccountPermission">
                        <i @click="allocationAccount(scope.row.enterpriseId, scope.row.id, scope.row.productId)" class="iconfont icon-distribution"></i>
                      </el-tooltip>
                      <el-tooltip content="查看" placement="top">
                        <i @click="viewAccountList(scope.row.enterpriseId, scope.row.id, scope.row.productId)" class="iconfont icon-view"></i>
                      </el-tooltip>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="90">
                  <template slot-scope="scope">
                    <el-button size="small" type="text" @click="deletePro(scope.row)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <div class="paging-box" v-if="pageTotal > 0">
                <el-pagination
                  background
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-sizes="[10, 20, 40, 80, 100]"
                  :page-size="pagesize"
                  layout="total, sizes, prev, pager, next"
                  :total="pageTotal"
                ></el-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
// 表单验证
import { notNullable, notNullableChange, sizeMax } from '@/components/form/formValidation'
export default {
  name: 'projectManage',
  data() {
    // const generateData = _ => {
    //   const data = []
    //   for (let i = 1; i <= 15; i++) {
    //     data.push({
    //       key: i,
    //       label: '新华新媒数据技术' + i,
    //       disabled: i % 4 === 0
    //     })
    //   }
    //   return data
    // }
    return {
      show: false,
      postLoading: false,
      nullShow: false,
      searchValue: '',
      projectList: [],
      projectSelection: [],
      // 分页相关
      currentPage: 1, // 初始当前显示页
      pagesize: 10, // 初始每页的数据条数
      pageTotal: 0, // 数据总条数
      // 弹窗
      // 添加/修改产品
      changeProductParam: {},
      changeProductList: [],
      productPopupTitle: '',
      operateProductType: '',
      operateProductId: '',
      operateProductVisible: false,
      operateProductForm: {
        name: ''
      },
      operateProductRules: {
        name: [notNullable('请填写产品名称')]
      },
      // 修改所属产品
      changeProductVisible: false,
      changeProductTitle: '',
      changeProductType: '',
      changeProjectId: 0,
      changeProjectIdList: [],
      changeProjectForm: {
        product: '',
        name: ''
      },
      changeProjectRules: {
        name: [notNullable('请填写项目名称'), sizeMax('项目名称', 40)]
      },
      // 分配投放账户
      assignAccountVisible: false,
      assignAccountProjectId: '',
      assignAccountProductId: '',
      deleteAssignedAccountList: [], // 删除投放账户
      assignAccountLoading: true,
      assignAccountForm: {
        list: []
      },
      // 全部投放账户
      assignAccountData: [],
      assignAccountRules: {
        list: [
          // notNullable('请选择要分配的账户')
        ]
      },
      // 查看投放账户
      viewAccountVisible: false,
      viewAccountId: '',
      viewAccountForm: {
        list: []
      },
      // 产品列表
      productListTotal: 0,
      opProductParam: {},
      activeProductId: 0,
      productList: [],
      // project:assignAccount
      assignAccountPermission: false,
      // project:assignProduct
      assignProductPermission: false,
      // project:editProjectName
      projectEditProjectName: false,
      chargeManVisible: false,
      chargeManForm: {
        employeeIdList: []
      },
      chargeManFormRules: {
        employeeIdList: [notNullableChange('请选择项目团队成员')]
      },
      employeeList: [],
      rowProjectId: ''
      // employeeIdList: []
    }
  },
  created() {
    this.assignAccountPermission = this.checkPermission('project:assignAccount')
    this.assignProductPermission = this.checkPermission('project:assignProduct')
    this.projectEditProjectName = this.checkPermission('project:editProjectName')
    // setInterval(() => {
    //   this.show = !this.show
    // }, 1001)
  },
  mounted() {
    console.log('userInfo', this.userInfo)
    this.getPageData(this.$route.path)
  },
  watch: {
    // 监测弹窗
    operateProductVisible(to, form) {
      if (to === false) {
        this.resetForm('operateProductForm')
        this.operateProductForm.name = ''
      }
    },
    changeProductVisible(to, form) {
      if (to === false) {
        this.resetForm('changeProjectForm')
        this.changeProjectForm.product = ''
      }
    },
    assignAccountVisible(to, form) {
      if (to === false) {
        this.resetForm('assignAccountForm')
        this.assignAccountForm.list = []
      }
    },
    chargeManVisible(to, form) {
      if (to === false) {
        this.resetForm('chargeManFormRef')
      }
    },
    $route(to) {
      this.getPageData(to.path)
    }
  },
  methods: {
    // startIntroJs() {
    //   if (parseInt(sessionStorage.getItem('isIntro'))) {
    //     let i = setInterval(() => {
    //       this.$guide([
    //         {
    //           title: '创建产品',
    //           intro: '描述(1/7)',
    //           element: document.querySelector('#guide-step1')
    //         },
    //         {
    //           title: '创建项目',
    //           intro: '文字描述文字描述文字描述文字描述文字描述文字描述文字描述(2/7)',
    //           element: document.querySelector('#guide-step2')
    //         }
    //       ])
    //       clearInterval(i)
    //     }, 500)
    //   }
    // },
    createProject() {
      if (!this.productList || this.productList.length === 0) {
        this.$confirm('请先创建产品', '提示', {
          confirmButtonText: '去创建',
          cancelButtonText: '取消'
        })
          .then(() => {
            this.operateProduct('add')
          })
          .catch(() => {

          })
      } else {
        this.$router.push({name: this.createProjectName})
      }
    },
    deletePro(row) {
      this.$confirm('删除后，项目下投放账户自动解除授权，是否确认删除此项目？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$service
            .post('/api/project/remove', {id: row.id})
            .then(res => {
              if (res.code === 200) {
                this.$message.success('操作成功!')
                // this.getProjectList(this.currentPage, this.pagesize)
                this.getPageData(this.$route.path)
              } else {
                this.$message.error(res.message)
              }
            })
            .catch(Err => {})
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          })
        })
    },
    chargeMan(row) {
      // this.chargeManForm.employeeIdList = row.
      this.getChargeManList()
      this.rowProjectId = row.id
      this.getChargeManIdList(row.id)
      this.chargeManVisible = true
    },
    chargeManSubmit() {
      this.$refs.chargeManFormRef.validate(valid => {
        if (valid) {
          //
          this.chargeManForm.projectId = this.rowProjectId
          this.$service.post('/api/project/editProjectChargeMan', this.chargeManForm).then(res => {
            if (res.code === 200) {
              this.chargeManVisible = false
              this.$message.success('修改成功!')
              this.getProjectList(this.currentPage, this.pagesize)
            }
          }).catch(Err => {

          })
        }
      })
    },
    getChargeManList() {
      // /api/targetAnalysis/getChargeManList 更换
      this.$service.post('/api/project/getChargeManList').then(res => {
        this.employeeList = res.result || []
      }).catch(Err => {

      })
    },
    getChargeManIdList(projectId) {
      this.$service.post('/api/project/getChargeManIdList', {projectId: projectId}).then(res => {
        this.chargeManForm.employeeIdList = res.result || []
      }).catch(Err => {

      })
    },
    getPageData(routePath) {
      if (routePath === '/accountManage/projectManage' || routePath === '/qianchuan/account/project') {
        // 获取产品列表
        this.getProductList()
        // 获取项目列表
        this.getProjectList(this.currentPage, this.pagesize)

        setTimeout(() => {
          // 获取投放账户列表
          this.getAccountData()
        }, 2000)
      } else {
        // 获取产品列表
        this.getProductList('employees')
      }
    },
    searchList(searchValue) {
      if (searchValue !== undefined) {
        this.getProjectList(this.currentPage, this.pagesize)
      }
    },
    // 获取投放账号数据
    getAccountData(valueList) {
      this.$service
        .post('/api/project/getAccountList4Select')
        .then(res => {
          console.log(res.result)
          // set数据
          this.assignAccountData = []
          let num = 0
          // console.log('valueList 当前项目绑定投放账户列表>>>>>>>>>>>>>>>>>>>>>>>>>>>>')
          // console.log(valueList)
          res.result.forEach((item, index) => {
            if (item.assignedStatus === 1) {
              item.assignedStatus = true
            } else {
              item.assignedStatus = false
            }
            if (valueList.indexOf(item.id) === -1) {
              // 未被项目关联的投放账户
              // console.log(item)
              this.assignAccountData[num] = {
                key: item.id,
                label: item.agentAccountName,
                disabled: item.assignedStatus
              }
            } else {
              // 已被项目关联的投放账户
              this.assignAccountData[num] = {
                key: item.id,
                label: item.agentAccountName
              }
            }
            num += 1
          })
          // console.log('assignAccountData 投放账户全部列表>>>>>>>>>>>>>>>>>>>>>>>>>>>>')
          // console.log(this.assignAccountData)
          // console.log(this.assignAccountData)
        })
        .catch(Err => {})
    },
    // 获取项目列表
    getProjectList(currentPage, pagesize) {
      this.$service
        .post('/api/project/getProjectList', {
          pageNum: currentPage,
          pageSize: pagesize,
          productId: this.activeProductId,
          projectName: this.searchValue
        })
        .then(res => {
          // console.log('getProjectList>>>>>>>>>>>>>>>>>>>>>>>>>>')
          this.projectList = res.result.pageData || []
          this.projectList.forEach(item => {
            let mstr = ''
            item.chargeManList.forEach(str => {
              mstr += str + '<br>'
            })
            item.chargeManList = mstr
          })
          this.pageTotal = res.result.total
        })
        .catch(Err => {})
    },
    // 获取产品列表
    getProductList(type) {
      this.$service
        .post('/api/project/getProductList')
        .then(res => {
          this.changeProductList = [
            {
              productName: '请选择',
              projectAmount: res.result.totalProjects,
              id: 0
            }
          ]
          res.result.list.forEach((item, index) => {
            this.changeProductList[index + 1] = item
          })
          // this.changeProductList = res.result.list
          this.productListTotal = res.result.totalProjects
          if (type === 'employees') {
            this.productList = [
              {
                productName: '请选择',
                projectAmount: res.result.totalProjects,
                id: ''
              }
            ]
            // this.departmentList = res.result.list
          } else {
            this.productList = [
              {
                productName: '全部',
                projectAmount: res.result.totalProjects,
                id: 0
              }
            ]
          }
          res.result.list.forEach((item, index) => {
            this.productList[index + 1] = item
          })
        })
        .catch(Err => {})
    },
    // 添加/编辑产品
    operateProduct(type, text, id) {
      if (type === 'add') {
        this.productPopupTitle = '添加产品'
        this.operateProductType = type
        this.operateProductVisible = true
      } else if (type === 'edit') {
        this.productPopupTitle = '编辑产品'
        this.operateProductId = id
        this.operateProductForm.name = text
        this.operateProductType = type
        this.operateProductVisible = true
      } else if (type === 'delete') {
        // 删除产品时，需要提示：当前产品下存在**个项目，请先删除项目
        let flag = false
        if (text > 0) {
          this.$confirm(`当前产品下存在${text}个项目，请先删除项目。`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消'
          })
            .then(() => {
              flag = true
              // /api/project/remove/product
            })
            .catch(() => {

            })
        } else {
          flag = true
        }
        if (flag) {
          this.$service
            .post('/api/project/remove/product', {id: id})
            .then(res => {
              if (res.code === 200) {
                this.$message.success('操作成功!')
                this.getPageData(this.$route.path)
              } else {
                this.$message.error(res.message)
              }
            })
            .catch(Err => {})
        }
      }
    },
    // 新增/编辑产品提交
    operateProductSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.operateProductType === 'add') {
            this.opProductParam = {
              productName: this.operateProductForm.name
            }
          } else if (this.operateProductType === 'edit') {
            this.opProductParam = {
              productName: this.operateProductForm.name,
              id: this.operateProductId
            }
          }
          // console.log(this.opProductParam)
          this.postLoading = true
          this.$service
            .post('/api/project/addProduct', this.opProductParam)
            .then(res => {
              this.$message({
                message: res.message,
                type: 'success'
              })
              // 刷新产品列表
              this.getProductList()
              // 刷新项目列表
              this.getProjectList(this.currentPage, this.pagesize)
              this.operateProductVisible = false
              this.postLoading = false
            })
            .catch(Err => {
              this.postLoading = false
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 产品切换刷新项目列表
    changeProductActive(id) {
      this.activeProductId = id
      this.getProjectList(this.currentPage, this.pagesize)
    },
    // 修改项目所属产品
    changeProject(type, id, productId, productName) {
      this.changeProjectIdList = []
      if (type === 'batch') {
        this.changeProductTitle = '所属产品'
        if (this.projectSelection.length < 1) {
          this.$message({
            message: '请选择需要分配的项目',
            type: 'warning'
          })
          return false
        }
        let list = []
        this.projectSelection.forEach((item, index) => {
          list[index] = item.id
        })
        this.changeProjectIdList = list
      } else if (type === 'editName') {
        this.changeProductTitle = '项目名称'
        console.log('修改项目名称')
        this.changeProjectForm.name = productName
        this.changeProjectId = id
      } else {
        this.changeProductTitle = '所属产品'
        // 编辑/新分配
        this.changeProjectIdList[0] = id
        if (type === 'edit') {
          // 编辑
          this.changeProjectForm.product = productId
        }
      }
      this.changeProductVisible = true
      this.changeProductType = type
    },
    changeProjectSubmit(formName, type) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (type === 'editName') {
            this.changeProductParam = {
              enterpriseId: this.userInfo.enterpriseId,
              projectId: this.changeProjectId,
              projectName: this.changeProjectForm.name
            }
            this.postLoading = true
            this.$service
              .post('/api/project/editProjectName', this.changeProductParam)
              .then(res => {
                this.$message({
                  message: res.message,
                  type: 'success'
                })
                // 刷新项目列表
                this.getProjectList(this.currentPage, this.pagesize)
                this.changeProductVisible = false
                this.postLoading = false
              })
              .catch(Err => {
                this.postLoading = false
              })
          } else {
            this.changeProductParam = {
              idList: this.changeProjectIdList,
              productId: this.changeProjectForm.product
            }
            this.$service
              .post('/api/project/assignProduct', this.changeProductParam)
              .then(res => {
                this.$message({
                  message: res.message,
                  type: 'success'
                })
                // 刷新产品列表
                this.getProductList()
                // 刷新项目列表
                this.getProjectList(this.currentPage, this.pagesize)
                this.changeProductVisible = false
              })
              .catch(Err => {})
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 分配关联账户
    allocationAccount(enterpriseId, projectId, productId) {
      this.getAssignedAccountList('distribution', enterpriseId, projectId, productId)
      this.assignAccountProjectId = projectId
      this.assignAccountProductId = productId
      this.assignAccountVisible = true
    },
    // 分配关联账户提交
    assignAccountSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          // console.log('分配账号>>>>>>>>>>>>>>' + id)
          this.$service
            .post('/api/project/assignAccount', {
              accountIdList: this.assignAccountForm.list,
              productId: this.assignAccountProductId,
              projectId: this.assignAccountProjectId
            })
            .then(res => {
              this.$message({
                message: res.message,
                type: 'success'
              })
              // 刷新投放账户列表
              this.getAccountData()
              this.assignAccountVisible = false
              this.deleteAssignedAccount()
            })
            .catch(Err => {})
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 查看账号
    viewAccountList(enterpriseId, projectId, productId) {
      this.getAssignedAccountList('view', enterpriseId, projectId, productId)
      this.viewAccountVisible = true
    },
    // 获取所有已关联账户
    getAssignedAccountList(type, enterpriseId, projectId, productId) {
      this.$service
        .post('/api/project/getAssignedAccountList', {
          enterpriseId: enterpriseId,
          productId: productId,
          projectId: projectId
        })
        .then(res => {
          if (type === 'view') {
            // 查看投放账户
            this.viewAccountForm.list = res.result
          } else {
            // this.assignAccountForm.list = []
            // 分配投放账户
            let list = []
            res.result.forEach((item, index) => {
              list[index] = item.id
            })
            this.assignAccountForm.list = list
            console.log(this.assignAccountForm.list)
            // console.log('valueList>>>>>>>>>>>>>>>>>>>')
            this.getAccountData(this.assignAccountForm.list)
            this.assignAccountLoading = false
          }
        })
        .catch(Err => {})
    },
    // 删除已关联投放账号
    deleteAssignedAccount() {
      // 删除列表置空
      this.deleteAssignedAccountList = []
      // 遍历全部投放账号列表
      this.assignAccountData.forEach((item, index) => {
        console.log(item.disabled)
        // valueList包含当前Key
        console.log(this.assignAccountForm.list.indexOf(item.key))
        if (this.assignAccountForm.list.indexOf(item.key) === -1) {
          if (item.disabled === false || item.disabled === undefined) {
            // 不在valueList中 可以选中删除
            this.$set(this.deleteAssignedAccountList, this.deleteAssignedAccountList.length, item.key)
          }
        }
      })
      if (this.deleteAssignedAccountList.length > 0) {
        console.log('删除投放账户list>>>>>>>>>>>>>>>>>>>>>>')
        console.log(this.deleteAssignedAccountList)
        this.$service
          .post('/api/project/deleteAssignedAccount', {
            accountId: this.deleteAssignedAccountList
          })
          .then(res => {
            // this.$message({
            //   message: res.message,
            //   type: 'success'
            // })
          })
          .catch(Err => {})
      }
    },
    // 切换数据显示条数
    handleSizeChange(size) {
      this.pagesize = size
      this.getProjectList(this.currentPage, size)
    },
    // 切换分页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage
      this.getProjectList(currentPage, this.pagesize)
    },
    // 保存选中结果
    handleSelectionChange(val) {
      this.projectSelection = val
    },
    // 穿梭框回调
    handleChange(value, direction, movedKeys) {
      // console.log(value)
    },
    // 重置表单
    resetForm(formName) {
      this.$refs[formName].resetFields()
    }
  },
  computed: {
    ...mapState(['userInfo']),
    createProjectName() {
      return this.$route.path.startsWith('/qianchuan') ? 'qccreateProject' : 'createProject'
    }
  }
}
</script>

<style lang="less">
@import './../../styles/accountManage/projectManage.less';
// .v-enter,.v-leave-to{
//   // animation: bounce-in 1s;
//   opacity: 1
// }
// .v-enter-active {
//   animation: bounce-in 1s;
// }
// .v-leave-active{
//   animation: bounce-in 0.9s reverse;
// }
// @keyframes bounce-in {
//   0% {
//     transform: scale(1.3);
//   }
//   50% {
//     transform: scale(1);
//   }
//   100% {
//     transform: scale(1.3);
//   }
// }
</style>



// WEBPACK FOOTER //
// src/views/accountManage/projectManage.vue